import styled from 'styled-components';

export const Label = styled.button`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  font-size: 13px;
  display: block;
  background: transparent;
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:not([disabled]):hover {
    background: rgba(0, 128, 255, 0.08);
    color: ${(props) => props.theme.colors.primaryText};
  }
  &:is([disabled]) {
    opacity: 0.5;
  }
`;
